import ExerciserEraseButton from "../../../buttons/courses/exercisers/ExerciserEraseButton";
import ExerciserValidationButton from "../../../buttons/courses/exercisers/ExerciserValidationButton";

export default function ExerciserBottomBar({isEraseButtonDisabled,
                                            onEraseButtonPressed,
                                            isValidationButtonDisabled,
                                            onValidateButtonPressed}) {
    // Used in Exercisers to display bottom bar with erase button
    // and validation slider

    // BUILD
    return (
        <div className={'mt-[16px] w-full flex space-x-[16px]'}>
            <ExerciserEraseButton isDisabled={isEraseButtonDisabled}
                                  onPressed={onEraseButtonPressed} />
            <ExerciserValidationButton onValidateButtonPressed={onValidateButtonPressed}
                                       isDisabled={isValidationButtonDisabled} />
        </div>
    )
}